import { render, staticRenderFns } from "./MidPolicy.vue?vue&type=template&id=4600df8e&scoped=true"
import script from "./MidPolicy.vue?vue&type=script&lang=js"
export * from "./MidPolicy.vue?vue&type=script&lang=js"
import style0 from "./MidPolicy.vue?vue&type=style&index=0&id=4600df8e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600df8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4600df8e')) {
      api.createRecord('4600df8e', component.options)
    } else {
      api.reload('4600df8e', component.options)
    }
    module.hot.accept("./MidPolicy.vue?vue&type=template&id=4600df8e&scoped=true", function () {
      api.rerender('4600df8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessHome/components/ClientUserWrap/MidPolicy.vue"
export default component.exports